import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { isEmptyObject, forwardTo } from '../../lib/utils';
import { loading, logout, updateKioskData } from '../../store/actions';
import { getConfig } from '../../appConfig';
import { PAUSE_TIMER, SET_COMMON_PROP, START_TIMER, STOP_TIMER } from '../../store/constants';
import api from '../../lib/api';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import { IonButton } from '@ionic/react';
import { SmallText } from '../../components/common';
import packageJson from '../../../package.json';
import asyncStorage from '../../lib/asyncStorage';

class KioskDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageCount: 0,
    };
  }

  async componentDidMount() {
    const { dispatch, profile, restaurants } = this.props;
    localStorage.removeItem('locale')
    if (!isEmptyObject(profile)) {
      this.props.dispatch(logout());
    }
        const search = this.props.location.search;

    const params = new URLSearchParams(search)
    if(params.get('clear_cache')){
      asyncStorage.removeItem('kioskData')
    }
    const kioskDataFromUrl = {
      kiosk_auth_email: params.get('email') || 'guest@5loyalty.com',
      kiosk_password: params.get('auth'),
      kiosk_zoom: params.get('zoom') || '100',
      kiosk_is_disabled: params.get('disabled'),
      kiosk_table_number: params.get('table_number'),
      pos_location: params.get('pos_location') || 'tml_EmdZwAFsuok3tO',
      full_screen_basket_mode: params.get('full_screen_basket_mode')
        ? Boolean(parseInt(params.get('full_screen_basket_mode')))
        : false,
      kiosk_default_menu_id: params.get('default_menu_id') || null,
    };
    if (!Basket.has_multi_basket) {
      kioskDataFromUrl.kiosk_restaurant_id = params.get('restaurant_id')
    }
    kioskDataFromUrl.kiosk_zoom =
      parseInt(kioskDataFromUrl?.kiosk_zoom) <= 100 ? '100' : kioskDataFromUrl?.kiosk_zoom;
    if (!this.props.location.state?.keepKioskData) {
      dispatch(updateKioskData(kioskDataFromUrl));
    }
    this.props.dispatch({ type: STOP_TIMER });
    this.props.dispatch({ type: SET_COMMON_PROP, key: 'restartOrderAlert', value: false });
    const restaurantId =
      kioskDataFromUrl?.kiosk_restaurant_id ||
      JSON.parse(localStorage.getItem('kioskData')).kiosk_restaurant_id ||
      null;
    let selectedRestaurant = this.props.restaurants.find((r) => r.id == restaurantId);
    let menusImages = []
    if (selectedRestaurant) {
      menusImages = await api.getImagesFromMenus(selectedRestaurant.business_location_id);
    } else if (Basket.has_multi_basket) {
      const restaurants = this.props.restaurants.filter(el => el.is_published)
      for (let i = 0; i < restaurants.length; i++) {
        const restaurantImages = await api.getImagesFromMenus(restaurants[i].business_location_id);
        menusImages.push(...restaurantImages)
      }
    }
    if (menusImages && menusImages.length > 0) {
      if (menusImages) {
        this.props.dispatch(loading(true));
        const imagesToPreload = menusImages
          .filter(Boolean)
          .map((el) => (el.indexOf('http://') !== -1 ? el.replace(/http:\/\//g, 'https://') : el));
        this.setState({ imagesToPreloadNum: imagesToPreload.length });
        document.querySelectorAll('.cached-img').forEach((el) => document.body.removeChild(el));
        for (let i = 0; i < imagesToPreload.length; i++) {
          const image = new Image();
          image.src = imagesToPreload[i];
          image.classList.add('cached-img');
          image.onload = () => {
            this.setState({ imageCount: this.state.imageCount + 1 });
          };
          document.body.appendChild(image);
        }
        this.props.dispatch(loading(false));
      }
    }
  }

  startOrder = () => {
    const { kiosk } = getConfig();
    const restartOrderTimer = kiosk ? kiosk?.restartOrderTimer : false;
    const restartTime = kiosk ? kiosk.restartTime : 120;
    if (restartOrderTimer)
      this.props.dispatch({ type: START_TIMER, data: restartTime, cb: this.timerHasEndedHandler });
    forwardTo('/delivery-options');
  };

  timerHasEndedHandler = () => {
    this.props.dispatch({ type: SET_COMMON_PROP, key: 'restartOrderAlert', value: true });
    this.props.dispatch({ type: PAUSE_TIMER });
  };

  render() {
    const { kiosk } = getConfig();
    const { kioskData, clientProfile, __ } = this.props;
    document.documentElement.style.setProperty('--zoom', `${kioskData.kiosk_zoom}%`);
    document.documentElement.style.setProperty('--zoom-value', `${kioskData.kiosk_zoom / 100}`);
    if (kioskData.kiosk_is_disabled === '1') {
      document.documentElement.style.setProperty(
        '--image-url',
        `url(${kiosk.disabledSplashImage ? kiosk.disabledSplashImage : ''})`,
      );
    } else {
      document.documentElement.style.setProperty(
        '--image-url',
        `url(${kiosk.splashImage ? kiosk.splashImage : ''})`,
      );
    }
    return (
      <Loading>
        <div
          className='absolute-content dashboard-wrapper large-padding'
          style={{ backgroundImage: kioskData.kiosk_is_disabled === '0' || !kioskData.kiosk_is_disabled ? `url(${kiosk.splashImage})` : `url(${kiosk.disabledSplashImage})` }}
          onClick={() => {
            if (kioskData.kiosk_is_disabled === '0' || !kioskData.kiosk_is_disabled) {
              this.startOrder();
            }
          }}
        >
          {!getConfig().kiosk.removeContentFromDashboard &&
            <div >
              {!getConfig().kiosk.removeLogoFromDashboard ? <img className='large-logo block' src={clientProfile.logo_image_light} /> : <div></div>}
              <IonButton expand='block' className='large-button'>{'Start your order'}</IonButton>
            </div>
          }
          <div className='app-version-block'>
            <SmallText>v{packageJson.version}</SmallText>
            <SmallText>{__('Online')}</SmallText>
          </div>
        </div>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { profile, vouchers, kioskData } = state.profile;
  const { clientProfile } = state.common
  const { restaurants } = state.restaurants
  return {
    profile: profile || {},
    vouchers: vouchers || [],
    kioskData: kioskData || {},
    restaurants: state.restaurants.restaurants || [],
    clientProfile,
    restaurants
  };
};

export default connect(stateToProps)(withTranslation(KioskDashboard));
